import { ref, onScopeDispose, getCurrentScope, type Ref } from 'vue'

export function useIsDarkMode(): Ref<boolean> {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return ref(false)
  }

  const root = document.documentElement
  const isDark = ref(root.classList.contains('dark'))

  const observer = new MutationObserver(() => {
    const next = root.classList.contains('dark')
    if (next !== isDark.value) isDark.value = next
  })

  observer.observe(root, { attributes: true, attributeFilter: ['class'] })

  if (getCurrentScope()) {
    onScopeDispose(() => observer.disconnect())
  }

  return isDark
}
